export default __webpack_public_path__ + "static/media/第五届全国人工智能大赛.ac92d65e.m4v";